<template>
    <div>
       <pm-local-list></pm-local-list>
    </div>
</template>

<script setup>
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import PmLocalList from '@/components/dashboard/projects/pm-local/PmLocalList.vue';
</script>
